import { MEMBERSHIP } from '../actionTypes';

const initialState = {
  selectedUser: {},
  content: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case MEMBERSHIP.SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case MEMBERSHIP.SELECTED:
      return {
        ...state,
        selectedUser: action.payload,
      };
    default:
      return state;
  }
};
